import { post as types } from '../../constants/types'
const post = {
    posts: [],
    post: {},
    loading: false,
    error: null
}
const reducer = (state = post, action) => {
    const data = action.payload;
    const posts = state.posts;
    const indexOfPost = posts.findIndex(obj => obj.id === data.id);
    switch (action.type) {
        case types.GET: return { ...state, posts: data };
        case types.POST: return { ...state, post: data };
        case types.PUSH: return { ...state, post: data, posts: [...posts, data] };
        case types.PUT: {
            posts[indexOfPost] = data;
            return { ...state, post: data, posts: posts };
        }
        case types.DELETE: {
            posts.splice(indexOfPost, 1);
            return { ...state, post: data, posts: posts };
        }
        case types.LOADING: return { ...state, loading: !state.loading };
        case types.ERROR: return { ...state, error: data };
        default: return state;
    }
};
export default reducer